import React from "react";
import Icon from "components/AppIcon";

export default function ClosingProgress({ raised, target, currency = "£", milestones = [], isCoInvestor = false }) {
  const pct = Math.min(100, Math.round((raised / target) * 100));

  const formatAmount = (n) =>
    n >= 1_000_000
      ? `${currency}${(n / 1_000_000)?.toFixed(1)}m`
      : `${currency}${(n / 1_000)?.toFixed(0)}k`;

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading text-base font-semibold text-foreground">Closing Progress</h3>
        <span
          className="font-data text-sm font-semibold px-2 py-1 rounded"
          style={{ background: "rgba(59,76,76,0.08)", color: "var(--color-primary)" }}
        >
          {isCoInvestor ? "75–90% funded" : `${pct}%`}
        </span>
      </div>
      <div className="flex items-end justify-between mb-2">
        <div>
          <p className="font-data text-xl font-semibold text-foreground">
            {isCoInvestor ? "—" : formatAmount(raised)}
          </p>
          <p className="font-caption text-xs text-muted-foreground">Raised</p>
        </div>
        <div className="text-right">
          <p className="font-data text-xl font-semibold text-muted-foreground">
            {isCoInvestor ? "—" : formatAmount(target)}
          </p>
          <p className="font-caption text-xs text-muted-foreground">Target</p>
        </div>
      </div>
      <div className="w-full h-3 bg-muted rounded-full overflow-hidden mb-4">
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{
            width: `${pct}%`,
            background: pct >= 80 ? "var(--color-success)" : "var(--color-primary)",
          }}
        />
      </div>
      {milestones?.length > 0 && (
        <div className="space-y-2">
          <p className="font-caption text-xs text-muted-foreground uppercase tracking-wide mb-2">Milestones</p>
          {milestones?.map((m, i) => (
            <div key={i} className="flex items-center gap-2">
              <div
                className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0"
                style={{
                  background: m?.done ? "var(--color-success)" : "var(--color-muted)",
                }}
              >
                <Icon
                  name={m?.done ? "Check" : "Clock"}
                  size={11}
                  color={m?.done ? "white" : "var(--color-muted-foreground)"}
                  strokeWidth={2.5}
                />
              </div>
              <span className={`font-caption text-xs ${m?.done ? "text-foreground" : "text-muted-foreground"}`}>
                {m?.label}
              </span>
              <span className="font-caption text-xs text-muted-foreground ml-auto">{m?.date}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}